import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "../views/layout/index.vue";
import UserCenter from "../views/layout/userCenter.vue";
import mobiles from "./mobile";
import addhome from "../views/cheat/addhome.vue";
import { add } from "lodash";

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};

// function isMobile() {
//   var ua = navigator.userAgent
//   var ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
//     isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
//     isAndroid = ua.match(/(Android)\s+([\d.]+)/),
//     isMobile = isIphone || isAndroid
//   if (isMobile) {
//     return true
//   }
//   return false
// }

// var ismob = isMobile()

var routes = [
    {
        path: "/micrologin/:number?",
        name: "MicroLogin",
        component: () => import("../views/MicroClass/MicroLogin.vue"),
        meta: { title: "推荐人登录" }
    },
    {
        path: "/microlist",
        name: "MicroList",
        component: () => import("../views/MicroClass/MicroList.vue"),
        meta: { title: "推荐人查询" }
    },
    {
        path: "/userCenter",
        redirect: { path: "/userCenter/info" }
    },
    {
        path: "/rules/:id",
        name: "rules",
        meta: { title: "考试守则页", icon: "dashboard", auth: "user" },
        component: () => import("../views/papers/rules.vue")
    },
    {
        path: "/entrance/:id",
        name: "entrance",
        meta: { title: "入口页", icon: "dashboard", auth: "user" },
        component: () => import("../views/papers/entrance.vue")
    },
    {
        path: "/main/:id",
        name: "main",
        meta: { title: "主页", icon: "dashboard", auth: "car" },
        component: () => import("../views/papers/main.vue")
    },
    {
        path: "/papertable",
        name: "paperTable",
        meta: { title: "顺序卷列表", icon: "dashboard", auth: "car" },
        component: () => import("../views/papers/paperTable.vue")
    },
    {
        path: "/personalPaper",
        name: "personalPaper",
        meta: { title: "顺序卷列表", icon: "dashboard", auth: "car" },
        component: () => import("../views/papers/personalPaper.vue")
    },
    {
        path: "/exam/:id",
        name: "exam",
        meta: { title: "考试页", icon: "dashboard", auth: "user" },
        component: () => import("../views/papers/exam.vue")
    },
    {
        path: "/verify/:id",
        name: "verify",
        meta: { title: "认证页", icon: "dashboard", auth: "user" },
        component: () => import("../views/papers/verify.vue")
    },
    {
        path: "/cert",
        name: "cert",
        meta: { title: "实名认证", icon: "dashboard", auth: "user" },
        component: () => import("../views/papers/Cert.vue")
    },
    {
        path: "/ks/exam_wp/:id",
        name: "exam_wp",
        meta: { title: "考试页", icon: "dashboard", auth: "user" },
        component: () => import("../views/papers/exam_wp.vue")
    },
    {
        path: "/examLogin",
        name: "examLogin",
        component: () => import("../views/cheat/examLogin.vue")
    },
    {
        path: "/ks/examVerify",
        name: "examVerify",
        component: () => import("../views/cheat/examVerify.vue")
    },
    {
        path: "/ks/takephoto/:id",
        name: "Takephoto",
        component: () => import("../views/sampling/takePhoto.vue"),
        meta: { title: "人脸采样" }
    },
    {
        path: "/practice",
        name: "practice",
        meta: { title: "错题练习", icon: "dashboard", auth: "car" },
        component: () => import("../views/papers/practice.vue")
    },

    {
        path: "/userCenter",
        name: "UserCenter",
        component: UserCenter,
        children: [
            {
                path: "/userCenter/:id",
                name: "UserInfo",
                component: () => import("../views/UserCenter.vue"),
                meta: { title: "反诈教育平台" }
            }
        ]
    },

    {
        path: "/",
        name: "addhome",
        component: Layout,
        children: [
            {
                path: "/",
                name: "addhome",
                component: () => import("../views/cheat/addhome.vue")
            },
            {
                path: "new",
                name: "New",

                component: () => import("../views/News.vue"),
                meta: { title: "" }
            },
            {
                path: "newsdet",
                name: "NewsDet",
                component: () => import("../views/NewsDesc.vue"),
                meta: { title: "反诈教育平台-资讯详情" }
            },

            {
                path: "news/:id",
                name: "News",

                component: () => import("../views/cheat/publicity.vue")
            },

            {
                path: "safety/:id?",
                name: "Safety",

                component: () => import("../views/cheat/safety.vue")
            },
            {
                path: "train/:id?",
                name: "Train",

                component: () => import("../views/cheat/train.vue")
            },
            {
                path: "sub",
                name: "Subject",

                component: () => import("../views/cheat/subject.vue")
            },
            {
                path: "certificate",
                name: "Certificate",

                component: () => import("../views/Certificate.vue"),
                meta: { title: "认证体系" }
            },
            {
                path: "gcertificate",
                name: "GCertificate",

                component: () => import("../views/GCertificate.vue"),
                meta: { title: "认证体系" }
            },
            {
                path: "guide",
                name: "Guide",

                component: () => import("../views/Guide.vue"),
                meta: { title: "反诈教育平台" }
            },
            {
                path: "syllabus",
                name: "Syllabus",

                component: () => import("../views/Syllabus.vue"),
                meta: { title: "反诈教育平台" }
            },
            {
                path: "invigilator",
                name: "Invigilator",

                component: () => import("../views/Invigilator.vue"),
                meta: { title: "反诈教育平台" }
            },
            {
                path: "course/:id?",
                name: "Course",

                component: () => import("../views/cheat/course.vue"),
                meta: { title: "反诈教育平台" }
            },
            {
                path: "login",
                name: "Login",

                component: () => import("../views/Login.vue"),
                meta: { title: "登录" }
            },
            {
                path: "regist/:agent?",
                name: "Regist",

                component: () => import("../views/Regist.vue"),
                meta: { title: "注册" }
            },
            {
                path: "reset",
                name: "Reset",

                component: () => import("../views/ResetPwd.vue"),
                meta: { title: "重置密码" }
            },
            {
                path: "evaluationnotes",
                name: "Evaluationnotes",

                component: () => import("../views/Evaluationnotes.vue"),
                meta: { title: "评测须知" }
            },
            {
                path: "simulation",
                name: "Simulation",

                component: () => import("../views/Simulation.vue"),
                meta: { title: "反诈教育平台" }
            },
            {
                path: "examination",
                name: "Examination",

                component: () => import("../views/Examination.vue"),
                meta: { title: "反诈教育平台" }
            },
            {
                path: "traincourse",
                name: "Traincourse",

                component: () => import("../views/Traincourse.vue"),
                meta: { title: "培训课程" }
            },
            {
                path: "firstpart",
                name: "FirstPart",

                component: () => import("../views/FirstPart.vue"),
                meta: { title: "在线评测" }
            },
            {
                path: "secondpart",
                name: "SecondPart",

                component: () => import("../views/SecondPart.vue"),
                meta: { title: "在线评测" }
            },
            {
                path: "thirdpart",
                name: "ThirdPart",

                component: () => import("../views/ThirdPart.vue"),
                meta: { title: "在线评测" }
            },
            {
                path: "people",
                name: "People",

                component: () => import("../views/Peoples.vue"),
                meta: { title: "反诈教育平台" }
            },
            {
                path: "videos",
                name: "videos",

                component: () => import("../views/cheat/videos.vue"),
                meta: { title: "专题列表" }
            },
            {
                path: "videolists/:id",
                name: "videolists",

                component: () => import("../views/cheat/videolists.vue"),
                meta: { title: "课程列表" }
            },
            {
                path: "videoplays/:cid/:uid/:id",
                name: "Videoplays",

                component: () => import("../views/cheat/videoplays.vue"),
                meta: { title: "视频播放" }
            },
            {
                path: "certsearch",
                name: "CertSearch",

                component: () => import("../views/CertSearch.vue"),
                meta: { title: "反诈教育平台" }
            },
            {
                path: "certinfo",
                name: "CertInfo",

                component: () => import("../views/CertInfo.vue"),
                meta: { title: "反诈教育平台" }
            },
            {
                path: "exam/:id",
                name: "Exam",

                component: () => import("../views/Exam.vue"),
                meta: { title: "评测" }
            },
            {
                path: "xy",
                name: "Xy",

                component: () => import("../views/Xy.vue"),
                meta: { title: "平台协议" }
            },
            {
                path: "question",
                name: "Question",

                component: () => import("../views/Question.vue"),
                meta: { title: "反诈网站QA常见问题" }
            },
            {
                path: "/:agent?",
                name: "Index",
                component: addhome
            }
        ]
    }
];

// if (ismob) {
//   routes = mobiles
// }

const router = new VueRouter({
    mode: "hash",
    routes
});

// router.onError((error) => {
//   const pattern = /Loading chunk (\d)+ failed/g;
//   const isChunkLoadFailed = error.message.match(pattern);
//   const targetPath = router.history.pending.fullPath;
//   if (isChunkLoadFailed) {
//   router.replace(targetPath);
//   }
//   });

export default router;
